import { render, staticRenderFns } from "./MentalHygieneView.vue?vue&type=template&id=c6982302&scoped=true&"
import script from "./MentalHygieneView.vue?vue&type=script&lang=js&"
export * from "./MentalHygieneView.vue?vue&type=script&lang=js&"
import style0 from "./MentalHygieneView.vue?vue&type=style&index=0&id=c6982302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6982302",
  null
  
)

/* custom blocks */
import block0 from "./MentalHygieneView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports